import React, { useEffect, useState, useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {
  Button,
  Paper,
  Grid,
  makeStyles,
  Typography,
  Card,
  ButtonBase
} from '@material-ui/core';
import { DragDropContext } from "react-beautiful-dnd";
import './index.scss';
import { deepOrange } from '@material-ui/core/colors';
import { Helmet } from 'react-helmet';
import uuid from "uuid/v4";
/**Connections */

import { METADATA } from '../../constants';
import Navbar from '../../components/Navbar';
import StandaloneToggleButton from '../../components/FileUpload/Folders';
import DropArea from './dropArea';
import DragArea from './dragArea';
import { isUndefined } from 'lodash';
import { uploadContentService } from '../../services';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import FolderStepper from '../../components/PlaylistCard/Steppers/FolderStepper';
import { convertXML } from 'simple-xml-to-json';

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: "#252525",

  },
}))(MuiDialogActions);
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'transparent',
    flexGrow: 1,
    padding: 15,
  },
  root1: {
    alignContent: 'center',
    width: 175,
    height: 215,
    textAlign: 'left',
    margin: 6,

  },
  dialogAction: {
    marginTop: 1,
  },
  media: {
    height: 90,
    margin: 15,

  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: '#252525',
    color: theme.palette.text.secondary,

  },
  textDesign: {
    textAlign: 'left',
    color: '#ff5722',
    fontSize: 30,
  },
  textDesign1: {
    textAlign: 'left',
    fontSize: 17,
    color: '#ffffff',
  },
  textDesign2: {
    textAlign: 'left',
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: 20,
  },
  buttonColor: {
    backgroundColor: '#ff5722',
    height: 40,
    width: 150,
    fontSize: 18,
    color: '#ffffff'
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
  },
  cardheader: {
    backgroundColor: deepOrange[500],
  },
}));

export default function Playlist() {
  let [cardMedia, setCardMedia] = useState({
    leftContent: [],
    rightContent: [],
    leftContentPerRow: [],
    isLoaded: false
  });
  let [folderName, setFolderName] = useState('ALT');
  const classes = useStyles();
  const { user } = useSelector(state => state.userAuthentication);
  const location = useLocation();
  const id = location.state.id;

  const getDynamicContentPlaylistDetail = useCallback(async () => {
    if (!isUndefined(user)) {
      let result1 = [];
      let result2 = [];
      let result3 = [];

      const res = await uploadContentService.dynamicContentPlaylistDetail(user, id);
      if (res.content.length > 0) {
        result1 = setLeftContentProp(res.content);
        result3 = computeItemsPerRow(result1);
      }
      const res2 = await uploadContentService.uploadContent(user);
      if (res2.items.length > 0)
        result2 = setRightContentProp(res2.items);

      cardMedia.rightContent = result2;
      cardMedia.isLoaded = true;
      cardMedia.playlistId = id;
      cardMedia.playlistName = res.name;
      cardMedia.leftContentPerRow = result3;
      cardMedia.leftContent = result1;

      if (!isUndefined(res.physicalPath)) {
        //parse xml
        parseXml(res.physicalPath);
      }
      else {
        setCardMediaProp();
      }
    }
  }, [user]);

  const parseXml = (url) => {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', uploadContentService.proxyServer + '/' + url);
    xhr.send();
    xhr.onload = function () {
      if (xhr.status != 200) { // analyze HTTP status of the response
        console.log(`Error ${xhr.status}: ${xhr.statusText}`); // e.g. 404: Not Found
      } else {
        let newData = xhr.responseXML;
        let rss = newData.children[0];
        let channel = rss.children[0];
        let channelChildren = channel.children;
        var items = [];
        for (let i = 0; i < channelChildren.length; i++) {
          if (channelChildren[i].tagName === 'item') {
            let itemChildren = channelChildren[i].children;

            var item = {
              videoTitle: '',
              videoUrl: '',
              thumbnailUrl: ''
            }

            for (let j = 0; j < itemChildren.length; j++) {
              let itemChild = itemChildren[j];
              if (itemChild.tagName === 'title') {
                item.videoTitle = itemChild.textContent;
              }
              else if (itemChild.tagName === 'media:content') {
                item.videoUrl = itemChildren[j].attributes[0].value;
                item.thumbnailUrl = itemChildren[j].children[0].attributes[0].value;
                console.log(item.thumbnailUrl);
              }
              if (j === itemChildren.length - 1)
                items.push(item);
            }
          }

          if (i === channelChildren.length - 1) {
            let leftContent = cardMedia.leftContent;
            items.map((item, indexItem) => {
              let leftContentsWithVidTitle = cardMedia.leftContent.filter(x => x.fileName === item.videoTitle);
              leftContentsWithVidTitle.map(itemContent => {
                let index = cardMedia.leftContent.findIndex(x => x.uniqueId === itemContent.uniqueId);
                leftContent[index].videoTitle = item.videoTitle;
                leftContent[index].videoUrl = item.videoUrl;
                leftContent[index].thumbnailUrl = item.thumbnailUrl;

              });
              if (indexItem === items.length - 1) {
                cardMedia.leftContent = leftContent;
                cardMedia.leftContentPerRow = computeItemsPerRow(leftContent);
                setCardMediaProp();
              }
            })
            console.log(items);
          }
        }
        // let channelItems2 = channel.children[0];
        // channel.children.map(item => {
        //   let test = item;
        //   console.log(test);
        // })
        // let info = channel.children[]
        console.log(newData);
      }
    };

    xhr.onprogress = function (event) {
      if (event.lengthComputable) {
        console.log(`Received ${event.loaded} of ${event.total} bytes`);
      } else {
        console.log(`Received ${event.loaded} bytes`); // no Content-Length
      }

    };

    xhr.onerror = function () {
      console.log("Request failed");
    };
  }

  const setRightContentProp = (items) => {
    let newItems = [];
    items.map(item => {
      newItems.push({
        uniqueId: uuid(),
        contentId: item.id,
        fileName: item.fileName,
        type: item.mediaType,
        folderName: item.name,
        videoTitle: item.videoTitle,
        thumbnailUrl: item.thumbnailUrl,
        videoUrl: item.videoUrl
      })
    });
    return newItems;
  }

  const setLeftContentProp = (items) => {
    console.log('items: ' + JSON.stringify(items));
    let newItems = [];
    items.map(item => {
      newItems.push({
        uniqueId: uuid(),
        contentId: item.contentId,
        fileName: item.fileName,
        type: item.mediaType,
        displayDuration: item.displayDuration,
        validityStartDate: item.validityStartDate,
        validityEndDate: item.validityEndDate,
        videoTitle: item.videoTitle,
        thumbnailUrl: item.thumbnailUrl,
        videoUrl: item.videoUrl
      })
    });
    return newItems;
  }

  if (cardMedia.isLoaded === false) {
    getDynamicContentPlaylistDetail();
  }

  useEffect(() => {
    let cardMediaTemp = sessionStorage.getItem('cardMedia');
    if (cardMediaTemp === null) {
      sessionStorage.setItem('cardMedia', JSON.stringify(cardMedia));
    }
    if (cardMedia.isLoaded === true) {
      sessionStorage.setItem('cardMedia', JSON.stringify(cardMedia));
      //get data from sessionStorage
      let cardMediaTemp2 = JSON.parse(cardMediaTemp);
      cardMedia = cardMediaTemp2;
    }
  }, [setCardMedia]);

  //sorting cards
  const reorderList = (list, startIndex, endIndex) => {
    const [removed] = list.splice(startIndex, 1);
    list.splice(endIndex, 0, removed);
    return list;
  };

  //clone cards
  const copy = (source, destination, droppableSource, droppableDestination) => {
    const item = source[droppableSource.index];
    destination.splice(droppableDestination.index, 0, { ...item, uniqueId: uuid() });
    return destination;
  };

  const setCardMediaProp = () => {
    setCardMedia({
      leftContent: cardMedia.leftContent,
      rightContent: cardMedia.rightContent,
      isLoaded: cardMedia.isLoaded,
      playlistId: cardMedia.playlistId,
      uniqueId: cardMedia.uniqueId,
      leftContentPerRow: cardMedia.leftContentPerRow,
      playlistName: cardMedia.playlistName,
      physicalPath: cardMedia.physicalPath
    })
  }

  const handleSaveContent = async () => {
    const res = await uploadContentService.updateContentEndpoint(user, cardMedia.leftContent, cardMedia.playlistId);
    if (res === '') {
      getDynamicContentPlaylistDetail();
    }
  }

  const computeItemsPerRow = (items) => {
    let newItems = [];
    let containerWidth = document.getElementById("contentContainer").offsetWidth;
    // let contentCardElement = document.getElementsByClassName(classes.root1)[0];
    if (containerWidth !== null) {
      //175 is the width of the card item from css
      let numberOfItemsPerRow = parseInt((containerWidth / 175) - 1);
      newItems = arrangeItemsPerRow(numberOfItemsPerRow, items);
      return newItems;
      // let mergedList = mergeList(newItems);
      // props.setLeftContentProp(mergedList);
    }
  }

  const arrangeItemsPerRow = (numberOfItemsPerRow, items) => {
    let newItems = [];
    let counter = 1;
    let perRowItems = [];
    let rowNumber = 1;
    let totalRemainingItems = items.length;
    items.map((item, index) => {
      if (counter > numberOfItemsPerRow) {
        counter = 1;
        perRowItems = [];
        rowNumber++;
      }

      if (counter < (numberOfItemsPerRow + 1)) {
        item.index = index;
        perRowItems.push(item);
        if (counter === numberOfItemsPerRow ||
          (totalRemainingItems < numberOfItemsPerRow && counter === totalRemainingItems)) {
          newItems.push({
            rowNumber: rowNumber,
            items: perRowItems,
          })
          totalRemainingItems = totalRemainingItems - numberOfItemsPerRow;
        }
        counter++;
      }
    });

    return newItems;
  }

  const mergeList = (list) => {
    let mergedList = [];
    list.map((item, index) => {
      item.items.map(item2 => {
        mergedList.push(item2)
      })
    });
    return mergedList;
  };

  const setSchedTimeCallback = (item) => {
    let leftContent = cardMedia.leftContent;
    let index = leftContent.findIndex(x => x.uniqueId === item.uniqueId);
    leftContent[index].validityEndDate = item.validityEndDate + ':00';
    leftContent[index].validityStartDate = item.validityStartDate + ':00';
    cardMedia.leftContent = leftContent;
    cardMedia.leftContentPerRow = computeItemsPerRow(cardMedia.leftContent);
    setCardMediaProp();
  }

  const removeContentCallback = (item) => {
    let leftContent = cardMedia.leftContent;
    leftContent = leftContent.filter(x => x.uniqueId !== item.uniqueId);
    cardMedia.leftContent = leftContent;
    cardMedia.leftContentPerRow = computeItemsPerRow(cardMedia.leftContent);
    setCardMediaProp();
  }

  const setDurationCallback = (item) => {
    let leftContent = cardMedia.leftContent;
    let index = leftContent.findIndex(x => x.uniqueId === item.uniqueId);
    leftContent[index].displayDuration = item.displayDuration;
    cardMedia.leftContent = leftContent;
    cardMedia.leftContentPerRow = computeItemsPerRow(cardMedia.leftContent);
    setCardMediaProp();
  }

  const getUploadContentSubfolder = useCallback(async (data) => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.uploadContentSubfolder(user, data);
      let result = [];
      if (res.items.length > 0)
        result = setRightContentProp(res.items);

      cardMedia.rightContent = result;
      setCardMediaProp();
    }
  }, [user]);

  const handleClickFolder = (event) => {
    const data = event.currentTarget.dataset.value;
    getUploadContentSubfolder(data);
    setFolderName(data);
  }

  const clickFolderStepperCallback = async (data) => {
    if (!isUndefined(user)) {
      if (data.position === 1) {
        const res = await uploadContentService.uploadContent(user);
        let result = [];
        if (res.items.length > 0)
          result = setRightContentProp(res.items);
        cardMedia.rightContent = result;
        setCardMediaProp();
      } else {
        getUploadContentSubfolder(data.name);
      }
      setFolderName(data.name);
    }
  }

  //react beautiful dnd on drag
  const onDragEnd = React.useCallback(
    result => {
      const { source, destination } = result;

      if (!destination) {
        return;
      }

      switch (source.droppableId) {
        case "SHOP":
          if (cardMedia.leftContent !== undefined) {
            if (cardMedia.leftContent.length > 0) {
              cardMedia.leftContent = copy(cardMedia.rightContent, cardMedia.leftContent, source, destination);
              cardMedia.leftContentPerRow = computeItemsPerRow(cardMedia.leftContent);
              cardMedia.rightContent = cardMedia.rightContent;
              cardMedia.isLoaded = cardMedia.isLoaded;
              cardMedia.playlistId = cardMedia.playlistId;
              cardMedia.playlistName = cardMedia.playlistName;
              cardMedia.physicalPath = cardMedia.physicalPath;
              setCardMediaProp();
            }
          }
          break;
        default:
          let isLeftContentToContent = destination.droppableId.includes('BAG') && source.droppableId.includes('BAG');
          if (isLeftContentToContent === false) {
            cardMedia.leftContent = reorderList(cardMedia.leftContent, source.index, destination.index);
            cardMedia.leftContentPerRow = computeItemsPerRow(cardMedia.leftContent);
          }
          else {
            let mergedList = mergeList(cardMedia.leftContentPerRow);
            let sourceIndex = result.source.index;
            let destinationIndex = result.destination.index;
            if (destinationIndex > sourceIndex) {
              if (destinationIndex === mergedList.length)
                destinationIndex = destinationIndex - 1;
            }
            cardMedia.leftContent = reorderList(mergedList, sourceIndex, destinationIndex);
            cardMedia.leftContentPerRow = computeItemsPerRow(cardMedia.leftContent);
          }

          cardMedia.rightContent = cardMedia.rightContent;
          cardMedia.isLoaded = cardMedia.isLoaded;
          cardMedia.playlistId = cardMedia.playlistId;
          cardMedia.playlistName = cardMedia.playlistName;
          cardMedia.physicalPath = cardMedia.physicalPath;
          setCardMediaProp();
          break;
      }
    },
    [setCardMedia]
  );
  return (
    <>
      <Helmet>
        <meta name="description" content={METADATA.PLAYLIST.description} />
        <title>{METADATA.PLAYLIST.title}</title>
      </Helmet>
      <Navbar />
      <div >
        <Grid container className={classes.root} justify="center" container spacing={3}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Grid item xs={8}>
              <Paper className={classes.paper} container spacing={3} item>
                <Typography className={classes.textDesign}>EDIT PLAYLIST - {cardMedia.playlistName} </Typography>
                <p className={classes.textDesign1}>Active files are shown below in a prioritised ordering</p>
                <Grid  >
                  <DropArea items={cardMedia.leftContentPerRow} setSchedTimeCallback={setSchedTimeCallback}
                    removeContentCallback={removeContentCallback} setDurationCallback={setDurationCallback}
                    itemsLeftContent={cardMedia.leftContent}
                  />
                </Grid>
              </Paper>
              <DialogActions className={classes.dialogAction}>
                <Button variant="contained" className={classes.buttonColor}
                  onClick={handleSaveContent}
                >SAVE</Button>
              </DialogActions>
            </Grid>
            <Grid container item xs={4}  >
              <Card className={classes.paper} cot justify="center">
                <Typography className={classes.textDesign}>ADD <span className={classes.textDesign2}>CONTENT</span></Typography>
                <p className={classes.textDesign1}>Drag files to add it to the playlist</p>
                <FolderStepper clickFolderStepperCallback={clickFolderStepperCallback} folderName={folderName} />
                <Grid container>
                  {
                    cardMedia.rightContent.filter(x => x.type === "Folder").map(item => {
                      if (item) {
                        return (
                          <ButtonBase className="content-folder" data-value={item.folderName} onClick={handleClickFolder}>
                            <Grid >
                              <StandaloneToggleButton className="folder-icon" item xs={12} sm={5} md={2} />
                              <h4 className="content-folder-label">{item.folderName}</h4>
                            </Grid>
                          </ButtonBase>
                        )
                      } else {
                        return null
                      }
                    })
                  }
                  <DragArea items={cardMedia.rightContent.filter(x => x.type === "Video")} />
                </Grid>
              </Card>
            </Grid>
          </DragDropContext>
        </Grid>
      </div>
    </>
  )
}